import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles, Theme } from '@material-ui/core/styles'
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'

import colorContext from '../../Context/colorContext'
import useChannelAttendances from '../../hooks/queries/use-channel-attendances'
import useServiceBySlug from '../../hooks/queries/use-service-by-slug'
import { ChannelAttendante } from '../Home/components'
import { Breadcrumb, ServiceDetais, Title } from './components'

interface Params {
  slug: string
  modal?: string
}

export default function ServiceIntegration(): JSX.Element {
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles((theme: Theme) => ({
    main: {
      width: '100%',
      minHeight: 400,
      display: 'flex',
      backgroundColor: colors.colorBackground,
      flexDirection: 'column',
      alignItems: 'center',
    },
  }))
  const classes = useStyles()
  const params: Params = useParams()

  const { data: service, isLoading: loading } = useServiceBySlug(params.slug)
  const { data: channels = [] } = useChannelAttendances()

  return (
    <Box className={classes.main}>
      {loading && (
        <Box
          marginBottom="60px"
          flex="1"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      )}
      {service && (
        <>
          <Breadcrumb service={service} slug={service.titulo} />
          <Title slug={service.titulo} service={service} />
          <ServiceDetais service={service} />
          <ChannelAttendante channelList={channels} />
        </>
      )}
    </Box>
  )
}
